import TrailHoverCard from './TrailHoverCard';

export default TrailHoverCard;
